/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryActivityLogResponse
 */
export interface RevisdomAPIViewModelsEntryActivityLogResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    fileId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    versionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    commentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    versionName?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserResponse}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    user?: RevisdomAPIViewModelsUserResponse;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    newValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryActivityLogResponse
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryActivityLogResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryActivityLogResponse(value: object): value is RevisdomAPIViewModelsEntryActivityLogResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryActivityLogResponseFromJSON(json: any): RevisdomAPIViewModelsEntryActivityLogResponse {
    return RevisdomAPIViewModelsEntryActivityLogResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryActivityLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryActivityLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'commentId': json['commentId'] == null ? undefined : json['commentId'],
        'versionName': json['versionName'] == null ? undefined : json['versionName'],
        'user': json['user'] == null ? undefined : RevisdomAPIViewModelsUserResponseFromJSON(json['user']),
        'oldValue': json['oldValue'] == null ? undefined : json['oldValue'],
        'newValue': json['newValue'] == null ? undefined : json['newValue'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function RevisdomAPIViewModelsEntryActivityLogResponseToJSON(json: any): RevisdomAPIViewModelsEntryActivityLogResponse {
    return RevisdomAPIViewModelsEntryActivityLogResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryActivityLogResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryActivityLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileId': value['fileId'],
        'versionId': value['versionId'],
        'commentId': value['commentId'],
        'versionName': value['versionName'],
        'user': RevisdomAPIViewModelsUserResponseToJSON(value['user']),
        'oldValue': value['oldValue'],
        'newValue': value['newValue'],
        'description': value['description'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

